// removed by extract-text-webpack-plugin
module.exports = {"spaceBetween":"audioPlayerLarge-module_spaceBetween_3oGwP","waveformContainer":"audioPlayerLarge-module_waveformContainer_HJ29_","timeContainer":"audioPlayerLarge-module_timeContainer_1jKIW","icon":"audioPlayerLarge-module_icon_M7BxM","spinningIcon":"audioPlayerLarge-module_spinningIcon_F84JX audioPlayerLarge-module_icon_M7BxM","spin":"audioPlayerLarge-module_spin_21SFC"};


//////////////////
// WEBPACK FOOTER
// ./client/components/audio/audioPlayerLarge.module.css
// module id = 1014
// module chunks = 1